import { partnerApi } from './api';

// Generate authorization URL for login
export const getAuthorizationUrl = async (organizationId?: string) => {
  const response = await partnerApi.getAuthorizationUrl(organizationId);
  return response.data.authorizationUrl;
};
